var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7803 5.46967C15.0732 5.76256 15.0732 6.23744 14.7803 6.53033L9.31066 12L14.7803 17.4697C15.0732 17.7626 15.0732 18.2374 14.7803 18.5303C14.4874 18.8232 14.0126 18.8232 13.7197 18.5303L7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697L13.7197 5.46967C14.0126 5.17678 14.4874 5.17678 14.7803 5.46967Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-left.eee4cc66ab0e3744e57485b9392b2485.svg";